import { render, staticRenderFns } from "./CampoEditEmisor.vue?vue&type=template&id=087d11d6&scoped=true"
import script from "./CampoEditEmisor.vue?vue&type=script&lang=js"
export * from "./CampoEditEmisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d11d6",
  null
  
)

export default component.exports